import CalendlyWidget from '../components/CalendlyWidget'
import './ContactPage.css'

function ContactPage() {
  // Replace 'your-calendly-username' with your actual Calendly username
  // Replace 'consultation' with your actual event type slug
  // Example: 'https://calendly.com/labspecialists/consultation'
  // In Vite, use VITE_ prefix for environment variables
  const CALENDLY_URL = import.meta.env.VITE_CALENDLY_URL || 'https://calendly.com/your-calendly-username/consultation'

  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p className="page-hero-subtitle">
            Have a question? We're here to help. Schedule a consultation or contact us directly.
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <div className="contact-details">
                <div className="contact-detail-item">
                  <h3>Text or Call</h3>
                  <a href="tel:+15416589374">(541) 658-9374</a>
                  <p className="contact-response-note">Response times typically under 60 minutes during business hours.</p>
                </div>
                <div className="contact-detail-item">
                  <h3>Email</h3>
                  <a href="mailto:info@labspecialists.com">info@labspecialists.com</a>
                </div>
                <div className="contact-detail-item">
                  <h3>Business Hours (PST)</h3>
                  <p>Monday - Friday: 8:00 AM - 6:00 PM PST</p>
                  <p>Saturday: 9:00 AM - 2:00 PM PST</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
              <div className="contact-note">
                <p>
                  <strong>For urgent matters:</strong> Please call us directly. For scheduling 
                  consultations, please use our{' '}
                  <a href="/booking">booking page</a>.
                </p>
              </div>
            </div>

            <div className="contact-form-section">
              <h2>Schedule a Consultation</h2>
              <p className="contact-form-intro">
                Book a free consultation to discuss your lab equipment needs. Select a time that works for you below.
              </p>
              <CalendlyWidget 
                url={CALENDLY_URL}
                pageSettings={{
                  backgroundColor: 'ffffff',
                  hideEventTypeDetails: false,
                  hideLandingPageDetails: false,
                  primaryColor: '1e40af', // Your primary blue color
                  textColor: '1f2937' // Your text color
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ContactPage
